module.exports = __webpack_public_path__ + "img/DE06212.505a4284.png";